import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'camelcasetospace' })
export class CamelCaseToSpacePipe implements PipeTransform {
  transform(string) {

    const myStr = camelCaseToSpace(string);

    return myStr;
  }
}

function camelCaseToSpace(myStr) {
  return myStr.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
}

